import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-my-bills-pay-status',
  standalone: true,
  imports: [],
  template: ``
})
export class MyBillsPayStatusComponent implements OnInit {

  private route: ActivatedRoute = inject(ActivatedRoute);

  public paymentToken: string | undefined = this.route.snapshot.queryParams['payment_token'] || this.route.snapshot.queryParams['payum_token'];

  public ngOnInit(): void {
    window.location.href = 'mobile-um-wronki://payment/status?paymentToken=' + this.paymentToken;
  }
}
